import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

import { SbGrid, SbHost, SbPanel, SbRoutes, SbWidget } from '@models';
import { Cacheable } from 'ts-cacheable';
import { AppConfigQuery } from '../../core/state/app-config/app-config.query';
import { MenuItem } from 'src/app/core/sb-menu/interfaces/menu';
import { IObservableCacheConfig } from 'ts-cacheable/common/IObservableCacheConfig';

@Injectable({
    providedIn: 'root'
})
export class SbLayoutConfigurationService {
    static cacheableConfig: IObservableCacheConfig = {
        maxAge: 60 * 60 * 1000,
        maxCacheCount: 10
    };

    gridPath = 'grids';
    widgetPath = 'widgets';
    panelPath = 'panels';
    menuPath = 'menus';
    routesPath = 'routes';
    routes: SbRoutes;

    constructor(private http: HttpClient, private config: AppConfigQuery) {}

    private getUrl(path: string): string {
        const baseUrl = this.config.getBaseUrlFromHost(SbHost.LayoutConfigurationBaseUrl);
        return baseUrl + '/' + path;
    }

    private get<T>(path: string): Observable<T> {
        return this.http.get<T>(this.getUrl(path)).pipe(share());
    }

    getGrids(): Observable<SbGrid[]> {
        return this.get(this.gridPath);
    }

    @Cacheable()
    getPanels(): Observable<SbPanel[]> {
        return this.get(this.panelPath);
    }

    getWidgets(): Observable<SbWidget> {
        return this.get(this.widgetPath);
    }

    @Cacheable(SbLayoutConfigurationService.cacheableConfig)
    getMenus(): Observable<MenuItem[]> {
        return this.get(this.menuPath);
    }

    getRoutes(): Observable<SbRoutes> {
        return this.get(this.routesPath);
    }
}
